/**
 * @file functions/setOrderShippingMethod.ts
 *
 * Utility function to set the shipping method for an order.
 *
 * @param {string} tokenValue - The token value for the order.
 * @param {string | number} shipmentId - The ID of the shipment to update.
 * @param {string} shippingMethod - The new shipping method to set.
 *
 * @returns {Promise<{ success: boolean; message: string }>} - The result of the address update.
 */

export async function setOrderShippingMethod(
  tokenValue: string, 
  shipmentId: string | number, 
  shippingMethod: string
) {
  try {
    const resp = await fetch(`/api/orders/${tokenValue}/shipments/${shipmentId}/`, {
      method: 'PATCH',
      body: JSON.stringify({
        shippingMethod: shippingMethod
      }),
      next: {
        revalidate: 0,
      },
    });

    switch (resp?.status) {
      case 200:
        return { success: true, message: '' };
      case 400: {
        const data = await resp.json();
        return { success: false, message: data.error ?? '' };
      }
      default:
        return { success: false, message: 'Unknown error' };
    }
  } catch {
    return { success: false, message: '' };
  }
}
